import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-feature-scroller',
  templateUrl: './feature-scroller.component.html',
  styleUrls: ['./feature-scroller.component.css']
})
export class FeatureScrollerComponent implements OnInit {

  @Input()
  showBack ?= true;

  @Input()
  enableNext = true;

  @Output()
  forward: EventEmitter<null>;

  @Output()
  back: EventEmitter<null>;

  constructor() {
    this.forward = new EventEmitter<null>();
    this.back = new EventEmitter<null>();
  }

  ngOnInit(): void {}
  
  goForward() {
    this.forward.emit();
  }

  goBack() {
    this.back.emit();
  }

}
